import { STORAGE_PREFIX } from "../types/geolocation.js";
import { useRef, useSyncExternalStore } from "react";
import { getLocalItem, setLocalItem } from "@myphx-engineering/browser-utils";

//#region src/hooks/use-geolocation.ts
const createStorageKey = function(cacheKey) {
	return cacheKey ? `${STORAGE_PREFIX}_${cacheKey}` : STORAGE_PREFIX;
};
const useGeolocation = (options) => {
	const latestValue = useRef(void 0);
	const storageKey = createStorageKey(options?.cacheKey);
	const localStore = {
		getSnapshot: () => {
			const storedData = getLocalItem(storageKey);
			if (!storedData) {
				latestValue.current = void 0;
				return null;
			}
			try {
				if (JSON.stringify(storedData) === JSON.stringify(latestValue.current) && latestValue.current !== void 0) return latestValue.current;
				latestValue.current = storedData;
				return latestValue.current;
			} catch (error) {
				console.error(error);
				return null;
			}
		},
		subscribe: (listener) => {
			const handleStorageChange = (e) => {
				if (e.key === storageKey) listener();
			};
			window.addEventListener("storage", handleStorageChange);
			return () => void window.removeEventListener("storage", handleStorageChange);
		}
	};
	return {
		geolocation: useSyncExternalStore(localStore.subscribe, localStore.getSnapshot) ?? void 0,
		setGeolocation
	};
};
const setGeolocation = (geolocation, options) => {
	const storageKey = createStorageKey(options?.cacheKey);
	try {
		setLocalItem(storageKey, geolocation);
		window.dispatchEvent(new StorageEvent("storage", {
			key: storageKey,
			newValue: geolocation ? JSON.stringify(geolocation) : null
		}));
	} catch (error) {
		console.error(error);
	}
};

//#endregion
export { useGeolocation };